import { createRoot } from 'react-dom/client'

import LayerControlToggle from './LayerControlToggle/LayerControlToggle'

import './layer-control.styl'

class LayerControl {
  constructor(map, style, setStyle) {
    this._container = null
    this.map = map
    this.style = style
    this.setStyle = setStyle
  }

  onAdd() {
    this._container = document.createElement('div')
    this._container.className = `maplibregl-ctrl maplibregl-ctrl-group maplibregl-ctrl-layer`

    const root = createRoot(this._container)
    root.render(<LayerControlToggle style={this.style} setStyle={this.setStyle} />)

    return this._container
  }

  onRemove() {
    if (this._root) {
      queueMicrotask(() => {
        this._root.unmount()
      })
    }
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container)
    }
  }
}

export default LayerControl
